import React, { Component } from "react";
import Dropdown from "react-dropdown";

export class linkCardStepTwo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: "Choose Account Type",
      accountType: "",
    };
  }

  // handleChangeSelect = (event) => {
  //   console.log('event.target.value', event.target.value)
  //   this.setState({
  //     value: event.target.value
  //   });
  // };
  handleOnclickSelect = (e) => {
    this.setState({
      accountType: e.value,
    });
    this.props.onChangeStep2Select(e.value);
  };

  render() {
    return (
      <div className="link-acc">
        <h3 className="text-center tab-h3">Add the information to link your bank account.</h3>
        
      </div>
    );
  }
}

export default linkCardStepTwo;
